import type { MouseEventHandler } from 'react'
import React from 'react'
import { Link } from 'react-router-dom'
import styles from './index.module.scss'
import { Badge } from 'react-bootstrap'
import { HeaderWidgetContainer } from '../../../components/Header/header-widget/HeaderWidgetContainer'
import { IconOnCircle } from '../../../components/icon-on-circle'

export type NotificationProps = {
  count: number
  icon: string
  href?: string | undefined
  onClick?: MouseEventHandler<HTMLAnchorElement> | undefined
}

export const NotificationWidget = ({ count, icon, href, onClick }: NotificationProps) => {
  return (
    <HeaderWidgetContainer>
      <Link className={styles.widgetHeader} to={href} onClick={onClick}>
        <IconOnCircle icon={icon} className="border">
          <span className={styles.notify}>
            <Badge bg="warning">{count}</Badge>
          </span>
        </IconOnCircle>
      </Link>
    </HeaderWidgetContainer>
  )
}
